document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('header-drawer a[href]');
  if (!(link instanceof HTMLAnchorElement) || link.hasAttribute('download')) return;
  if (link.target && link.target !== '_self') return;

  const destination = new URL(link.href);
  if (!destination.hash || destination.origin !== location.origin) return;
  if (destination.pathname !== location.pathname || destination.search !== location.search) return;

  const drawer = link.closest('header-drawer');
  if (drawer?.isOpen && typeof drawer.close === 'function') drawer.close();
});
